import { Result } from 'antd';
import { ErrorInfo } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';

// const onError = (err: Error, info: { componentStack: string }) => {
//     console.error('ErrorBoundary', err.message, info);
// };
const onError = (err: Error, info: ErrorInfo) => {
    console.error('ErrorBoundary', err.message, info);
};

const Fallback = ({ error, resetErrorBoundary }: FallbackProps) => {
    setTimeout(() => {
        resetErrorBoundary();
    }, 10000);

    return (
        <div role="alert">
            <Result status="error" title="Failed" subTitle={error.message} />
        </div>
    );
};

export const ErrorElement = (
    <ErrorBoundary FallbackComponent={Fallback} onError={onError} />
);
